import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const userApi = {
  getUsers: async ({ page = 1, perPage = 10, search = '', includeTrashed = false } = {}) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.USERS}`, {
        params: { page, per_page: perPage, search, trashed: includeTrashed ? 'true' : 'false' },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  },

  getUserByIdentifier: async (identifier) => {
    try {
      const url = `${API_ENDPOINTS.USERS}/${identifier}`;
      const response = await apiClient.get(url);
      return response.data;
    } catch (error) {
      console.error(`Error fetching user ${identifier}:`, error);
      throw error;
    }
  },

  createUser: async (userData) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.USERS}`, userData);
      return response.data;
    } catch (error) {
      console.error('Error creating user:', error);
      throw error;
    }
  },

  updateUser: async (identifier, userData) => {
    try {
      userData.append('_method', 'PUT');
      const response = await apiClient.post(`${API_ENDPOINTS.USERS}/${identifier}`, userData);
      return response.data;
    } catch (error) {
      console.error(`Error updating user ${identifier}:`, error);
      throw error;
    }
  },

  trashUser: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.USERS}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error trashing user ${identifier}:`, error);
      throw error;
    }
  },

  restoreUser: async (identifier) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.USERS}/${identifier}/restore`);
      return response.data;
    } catch (error) {
      console.error(`Error restoring user ${identifier}:`, error);
      throw error;
    }
  },

  permanentDeleteUser: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.USERS}/${identifier}/permanent-delete`);
      return response.data;
    } catch (error) {
      console.error(`Error permanently deleting user ${identifier}:`, error);
      throw error;
    }
  },
};

export default userApi;